<section class="treatment-plan-dialog__container">
  <div class="treatment-plan-dialog__backdrop"></div>
  <article class="treatment-plan-dialog">
    <header>
      <img alt="NUHS" class="object-cover w-full relative -top-8" src="/ncis-assets/images/version/logo-NUHS.png" />
      <button (click)="continueEvent.emit()">
        <ncis-common-icon
          [folder]="'general'"
          [name]="'close'"
          [extraClass]="'h-5 w-5 text-ncis-neutral-800'"
        ></ncis-common-icon>
      </button>
    </header>
    <main>
      <h2>Treatment Plan</h2>
      <section>
        <article>
          <div class="treatment-plan-dialog__overview">
            <h5>🧬 Treatment Overview</h5>
          </div>
          <p>Your treatment plan has been updated.</p>
          <ul *ngIf="treatmentPlanData.treatmentType || treatmentPlanData.treatmentRegimen">
            <li *ngIf="treatmentPlanData.treatmentType" class="treatment-plan-dialog__indent">
              <span>Treatment type</span>: {{ treatmentPlanData.treatmentType | titlecase }}
            </li>
            <li *ngIf="treatmentPlanData.treatmentRegimen" class="treatment-plan-dialog__indent">
              <span>Chemotherapy regimen</span>: {{ treatmentPlanData.treatmentRegimen }}
            </li>
          </ul>
          <p>
            You can review your updated plan in the app or reach out to your care team if you have any questions or concerns.
          </p>
        </article>
      </section>
    </main>
    <footer>
      <button (click)="continueEvent.emit()">
        Continue
      </button>
    </footer>
  </article>
</section>
